import { Box, Stack, Typography, Button } from '@mui/material';
import { InfoOutlined, Refresh } from '@mui/icons-material';
import { AISuggestionsTitle } from './AISuggestionsTitle';

export interface AISuggestionsErrorStateProps {
  onRetry: () => void;
  onRenameManually: () => void;
}

export const AISuggestionsErrorState = ({
  onRetry,
  onRenameManually,
}: AISuggestionsErrorStateProps) => (
  <Stack gap={1}>
    <AISuggestionsTitle />
    <Box
      style={{
        border: '1px solid #dc3545',
        borderRadius: '8px',
        padding: '12px',
        backgroundColor: '#fef2f2',
      }}
    >
      <Box
        style={{
          display: 'flex',
          alignItems: 'flex-start',
          gap: '8px',
          marginBottom: '12px',
        }}
      >
        <InfoOutlined
          style={{ color: '#721c24', fontSize: '16px', marginTop: '2px' }}
        />
        <Box>
          <Typography
            variant="body2"
            fontWeight={600}
            style={{ color: '#5a1a1a' }}
          >
            AI Processing Failed
          </Typography>
          <Typography variant="body2" style={{ color: '#721c24' }}>
            We can&apos;t process the document. AI can&apos;t process it.
          </Typography>
        </Box>
      </Box>
      <Box
        style={{ display: 'flex', gap: '8px', justifyContent: 'flex-start' }}
      >
        <Button
          variant="outlined"
          size="small"
          onClick={onRetry}
          startIcon={<Refresh style={{ fontSize: '12px' }} />}
          style={{
            color: '#721c24',
            borderColor: '#f5c6cb',
            backgroundColor: '#ffffff',
            borderRadius: '6px',
            fontSize: '11px',
            padding: '4px 8px',
            minWidth: 'auto',
            height: '28px',
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.backgroundColor = '#721c24';
            e.currentTarget.style.color = '#ffffff';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = '#ffffff';
            e.currentTarget.style.color = '#721c24';
          }}
        >
          Retry
        </Button>
        <Button
          variant="outlined"
          size="small"
          onClick={onRenameManually}
          style={{
            color: '#721c24',
            borderColor: '#f5c6cb',
            backgroundColor: '#ffffff',
            borderRadius: '6px',
            fontSize: '11px',
            padding: '4px 8px',
            minWidth: 'auto',
            height: '28px',
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.backgroundColor = '#721c24';
            e.currentTarget.style.color = '#ffffff';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = '#ffffff';
            e.currentTarget.style.color = '#721c24';
          }}
        >
          Rename Manually
        </Button>
      </Box>
    </Box>
  </Stack>
);
